import { useQuery } from 'react-query';
import QUERY_CACHE_KEY from '@src/constants/QueryCacheKey';

function useMeQuery(options) {
  return useQuery(QUERY_CACHE_KEY.me(), {
    staleTime: 10 * 60 * 1000,
    ...options,
  });
}

export default useMeQuery;
